module.exports = __webpack_public_path__ + "img/pirates-adventure.744e38ac.jpg";